import { Link, useLocation } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'

const services = [
  { path: '/strategy', name: 'Strategy', tagline: 'Digital Consulting' },
  { path: '/growth', name: 'Growth', tagline: 'Performance marketing' },
  { path: '/design', name: 'Design', tagline: 'Brand & Identity' },
  { path: '/engineering', name: 'Engineering', tagline: 'Web Development' },
  { path: '/insights', name: 'Insights', tagline: 'Web Analytics' },
  { path: '/automation', name: 'Automation', tagline: 'Artificial Intelligence' },
  { path: '/authority', name: 'Authority', tagline: 'SEO & Content' },
]

export default function ServiceNav() {
  const { pathname } = useLocation()
  const otherServices = services.filter((s) => s.path !== pathname)

  return (
    <section className="py-14 md:py-20 bg-slate-50 border-t border-slate-200">
      <div className="container px-4 md:px-6">
        <h2 className="text-sm font-bold text-accent uppercase tracking-[0.2em] mb-6">More Services</h2>
        <nav className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {otherServices.map((service) => (
            <Link
              key={service.path}
              to={service.path}
              className="group flex items-center gap-4 p-4 md:p-5 rounded-xl border border-slate-200 bg-white shadow-sm hover:shadow-lg hover:border-accent/40 transition-all duration-300"
            >
              <div className="flex-1 min-w-0">
                <h3 className="font-bold font-heading text-primary text-lg md:text-xl uppercase tracking-tight mb-1 group-hover:text-accent transition-colors">
                  {service.name}
                </h3>
                <p className="text-slate-500 text-sm">{service.tagline}</p>
              </div>
              <span className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full border border-slate-200 bg-slate-50 group-hover:border-accent/40 group-hover:bg-accent/5 transition-all">
                <ArrowRight className="h-4 w-4 text-accent group-hover:translate-x-0.5 transition-transform" />
              </span>
            </Link>
          ))}
        </nav>
      </div>
    </section>
  )
}
